import loadable from '@loadable/component';

const TermsLoadable = loadable(() => import(/* webpackChunkName: 'terms' */ './Terms'));

const Terms = () => <TermsLoadable />;

export default Terms;
